import { useState } from 'react';
import { collection, addDoc, serverTimestamp } from 'firebase/firestore';
import { db } from '../../lib/firebase';

const useSubmitOrder = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState(null);

  const submitOrder = async (orderData) => {
    console.log('Submitting order to Firestore:', orderData);
    setIsSubmitting(true);
    setError(null);

    try {
      const docRef = await addDoc(collection(db, 'orders'), {
        ...orderData,
        status: 'pending',
        createdAt: serverTimestamp(),
      });
      console.log('Order added to Firestore with ID:', docRef.id);
      setIsSubmitting(false);
      return docRef.id;
    } catch (err) {
      console.error('Error submitting order:', err);
      setError(err.message);
      setIsSubmitting(false);
      return null;
    }
  };

  return { submitOrder, isSubmitting, error };
};

export default useSubmitOrder;
